// extracted by mini-css-extract-plugin
export default {"MainStats":"styles_MainStats__xdHlV"};